import { Col, Input, Row, Select } from 'antd';
import NumberFormat from 'react-number-format';

import {
  SankhyaCompany,
  SankhyaDepartment,
  SankhyaJobPostingDetail,
  SankhyaJobRole,
} from '../types';
import Form from './Form';

interface SankhyaAdmissionFormProps {
  sankhyaJobPosting?: SankhyaJobPostingDetail;
  sankhyaCompanies: SankhyaCompany[];
  sankhyaJobRoles: SankhyaJobRole[];
  sankhyaDepartments: SankhyaDepartment[];
}

const SankhyaAdmissionForm = ({
  sankhyaJobPosting,
  sankhyaCompanies,
  sankhyaJobRoles,
  sankhyaDepartments,
}: SankhyaAdmissionFormProps) => {
  return (
    <>
      <Form.Item label="E-mail" name="candidateEmail" rules={[{ required: true }]}>
        <Input disabled />
      </Form.Item>
      <Form.Item label="CPF" name="candidateCPF" rules={[{ required: true }]}>
        <NumberFormat
          format="###.###.###-##"
          customInput={Input}
          data-testid="candidate-cpf-input"
          disabled
        />
      </Form.Item>
      <Form.Item label="Cargo" name="sankhyaJobRole" rules={[{ required: true }]}>
        <Select
          showSearch
          filterOption={(input, option) =>
            (option?.children as unknown as string).toLowerCase().includes(input.toLowerCase())
          }
          disabled={!!sankhyaJobPosting?.job_role}
          data-testid="select-sankhya-job-role"
        >
          {sankhyaJobRoles.map(({ CODCARGO, DESCRCARGO }) => (
            <Select.Option key={CODCARGO} value={`${CODCARGO}`}>
              {`${CODCARGO} - ${DESCRCARGO}`}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Form.Item label="Empresa" name="sankhyaCompany" rules={[{ required: true }]}>
            <Select
              showSearch
              filterSort={(optionA, optionB) =>
                ((optionA?.label as unknown as string) ?? '').localeCompare(
                  (optionB?.label as unknown as string) ?? ''
                )
              }
              filterOption={(input, option) =>
                (option?.label as unknown as string).toLowerCase().includes(input.toLowerCase())
              }
              disabled={!!sankhyaJobPosting?.company}
              data-testid="select-sankhya-company"
            >
              {sankhyaCompanies.map(({ CODEMP, Empresa_NOMEFANTASIA }) => (
                <Select.Option key={CODEMP} value={`${CODEMP}`} label={`${Empresa_NOMEFANTASIA}`}>
                  <span
                    title={CODEMP}
                    data-testid={`select-sankhya-company-${CODEMP}`}
                  >{`${Empresa_NOMEFANTASIA}`}</span>
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Departamento" name="sankhyaDepartment" rules={[{ required: true }]}>
            <Select
              showSearch
              filterSort={(optionA, optionB) =>
                ((optionA?.label as unknown as string) ?? '').localeCompare(
                  (optionB?.label as unknown as string) ?? ''
                )
              }
              filterOption={(input, option) =>
                (option?.children as unknown as string).toLowerCase().includes(input.toLowerCase())
              }
              disabled={!!sankhyaJobPosting?.department}
              data-testid="select-sankhya-department"
            >
              {sankhyaDepartments.map(({ CODDEP, DESCRDEP }) => (
                <Select.Option key={CODDEP} value={`${CODDEP}`} label={`${DESCRDEP}`}>
                  {`${CODDEP} - ${DESCRDEP}`}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default SankhyaAdmissionForm;
